<div class="transport-options-editor no-field-space">
    <sc-padding>
        <form [formGroup]="optionFormGroup">
            <mat-slide-toggle formControlName="amountOfPallettesMandatory" name="amountOfPallettesMandatory">
                {{'amount of pallettes mandatory' | translate:
                ['tmc-yard.entity.transport-option.amount-of-pallettes-mandatory',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountOfBoxesMandatory" name="amountOfBoxesMandatory">
                {{'amoutr of boxes mandatory' | translate:
                ['tmc-yard.entity.transport-option.amount-of-boxes-mandatory',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountInKilogrammMandatory" name="amountInKilogrammMandatory">
                {{'amount in kilogramm mandatory' | translate:
                ['tmc-yard.entity.transport-option.amount-in-kilogramm-mandatory',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountInLiterMandatory" name="amountInLiterMandatory">
                {{'amount in liter mandatory' | translate:
                ['tmc-yard.entity.transport-option.amount-in-liter-mandatory',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountOthersMandatory" name="amountOthersMandatory">
                {{'amount others mandatory' | translate:
                ['tmc-yard.entity.transport-option.amount-others-mandatory',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountMandatoryInTerminal" name="amountMandatoryInTerminal">
                {{'amount mandatory in terminal' | translate:
                ['tmc-yard.entity.transport-option.amount-mandatory-in-terminal',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-slide-toggle formControlName="amountMandatoryInTime" name="amountMandatoryInTime">
                {{'amount mandatory in time' | translate:
                ['tmc-yard.entity.transport-option.amount-mandatory-in-time',
                translationService.language]}}
            </mat-slide-toggle>
        </form>
    </sc-padding>
</div>